import React from "react";
import ReactApexChart from "react-apexcharts";

export const StatusChart = ({ paid = 44, upcoming = 55, unpaid = 41 }) => {
    const series = [paid, unpaid];

    const options = {
        chart: {
            type: "donut",
            height: 300,
        },
        labels: ["Paid", "Unpaid"],
        colors: ["#006E7E", "#006E7E1A"], // green, yellow, red (customizable)
        dataLabels: {
            enabled: false, // ✅ hides percentages or value labels
        },
        legend: {
            position: "bottom",
            horizontalAlign: "center",
            fontSize: "14px",
            markers: {
                width: 12,
                height: 12,
                borderRadius: 0,
            },
            itemMargin: {
                horizontal: 10,
                vertical: 5,
            },
        },
        tooltip: {
            enabled: false, // ✅ disables hover tooltips
        },
        stroke: {
            show: false, // ✅ removes donut outline
        },
        responsive: [
            {
                breakpoint: 480,
                options: {
                    chart: {
                        width: 250,
                    },
                    legend: {
                        position: "bottom",
                    },
                },
            },
        ],
    };

    return (
        <div style={{ textAlign: "center" }}>
            <ReactApexChart options={options} series={series} type="donut" height={300} />
        </div>
    );
};
